import React, { useState } from "react";
import { ChevronLeft, ChatLeftDotsFill } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion2.module.scss";
const Accardion2 = () => {
  const [openOnClickList , setOpenOnClickList]=useState(false)
  const [openOnClickUser , setOpenOnClickUser]=useState(false)
  const [openAll , setOpenAll]=useState(false)
  const userList = [
    {
      id: "1",
      title: "مشتری",
      link: "/customer",
      active: window.location.pathname === "/customer",
    },
    {
      id: "2",
      title: "تامین کننده",
      link: "/supplier",
      active: window.location.pathname === "/supplier",
    },
    // {
    //   id: "3",
    //   title: "پیک",
    //   link: "/delivery",
    //   active: window.location.pathname === "/delivery",
    // },
    {
      id: "4",
      title: "ادمین",
      link: "/admin",
      active: window.location.pathname === "/admin",
    },
    {
      id: "5",
      title: "راننده و پیک",
      link: "/driver",
      active: window.location.pathname === "/driver",
    },
  ];

  let valueUserList = false;
  userList.forEach((element) => {
    if (element.active) {
      valueUserList = true;
    }
  });

  const openHandler=()=>{
    if(openOnClickList){
      setOpenOnClickList(false)
    }
    else{
      setOpenOnClickList(true)
    }
  }

  const addUserList = [
    // {
    //   id: "1",
    //   title: "مشتری",
    //   link: "/addcustomer",
    //   active: window.location.pathname === "/addcustomer",
    // },
    {
      id: "1",
      title: "تامین کننده",
      link: "/addsupplier",
      active: window.location.pathname === "/addsupplier",
    },
    // {
    //   id: "2",
    //   title: "پیک",
    //   link: "/adddelivery",
    //   active: window.location.pathname === "/adddelivery",
    // },
    {
      id: "3",
      title: "ادمین",
      link: "/addadmin",
      active: window.location.pathname === "/addadmin",
    },
    {
      id: "4",
      title: "راننده و پیک",
      link: "/adddriver",
      active: window.location.pathname === "/adddriver",
    },
  ];
  let valueAddUser = false;
  addUserList.forEach((element) => {
    if (element.active) {
      valueAddUser = true;
    }
  });

  const openHandlerAdd=()=>{
    if(openOnClickUser){
      setOpenOnClickUser(false)
    } 
    else{
      setOpenOnClickUser(true)
    }
  }

  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.component}>
      <div className={Style.accardionChild}>
        <div
          className={Style.accardionTitle}
          onClick={openHandlerAll}
        >
          <ChevronLeft />
          <div className={Style.right}>
            <p className={Style.accardionText}>کاربر</p>
            <ChatLeftDotsFill />
          </div>
        </div>
        <div className={valueUserList || valueAddUser ||openAll  ? Style.holder:Style.hidden}>
          <div className={Style.accardionContent}>
            <div 
              onClick={openHandler}
              className={valueUserList||openOnClickList?Style.background :Style.innerAccardionTitle}
            >
              <ChevronLeft />
              <div className={Style.right}>
                <p className={Style.accardionText}>لیست کاربر</p>
              </div>
            </div>
            <div className={valueUserList||openOnClickList?Style.inneraccardionContent :Style.hidden }>
              <AccardionItem accardonItem={userList && userList}/>
            </div>
          </div>

          <div className={Style.accardionContent}>
            <div 
              onClick={openHandlerAdd}
              className={valueAddUser||openOnClickUser?Style.background :Style.innerAccardionTitle}
            >
              <ChevronLeft />
              <div className={Style.right}>
                <p className={Style.accardionText}>افزودن کاربر</p>
              </div>
            </div>
            <div className={valueAddUser||openOnClickUser?Style.inneraccardionContent :Style.hidden }>
              <AccardionItem accardonItem={addUserList && addUserList}/>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Accardion2;
